import { Checkbox, DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutReceivablesHistory extends Layout {
    checkboxDisplayChildBridgeAccounts: Checkbox;
    checkboxIsIntercompany: Checkbox;
    checkboxIsSplitBill: Checkbox;
    searchpanelReceivablesHistory: SearchPanel;
    sourceReceivablesHistory: DataSource;
    tableReceivablesHistory: Table;
    textboxArReasonCodeId: Textbox;
    textboxBillDate: Textbox;
    textboxCompanyId: Textbox;
    textboxCustomerId: Textbox;
    textboxDepositNumber: Textbox;
    textboxGlDate: Textbox;
    textboxOrderId: Textbox;
    textboxRecordType: Textbox;
    textboxReferenceNumber: Textbox;
    textboxShipDate: Textbox;
    textboxSource: Textbox;
}
